<!-- <div class="w-100 d-flex justify-content-center kiosk-header">
    <img [src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + kioskService.venueService.venueKey + '/logo.png'">
</div> -->
<div style="height: 100vh">
	<app-kiosk-menu-categories *ngIf="!canvasKeySelected" (canvasKeySelectedEmitter)="canvasKeySelected = $event"></app-kiosk-menu-categories>

	<div class="d-flex w-100 h-100">
		<div *ngIf="canvasKeySelected" class="w-33 d-flex flex-column amimation-slide-in-bottom animation-duration-2s overflow-scroll border-right">
			<ng-container *ngFor="let rec of kioskService.kioskMenu">
				<div class="p-lg-3 p-md-4 p-col-12 card w-100 mb-5" (click)="canvasKeySelected = rec.canvasKey">
					<div class="d-flex flex-column justify-content-center">
						<div class="text-center">
							<img
								*ngIf="rec.imageKey"
								width="100%"
								[src]="
									'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
									kioskService.venueService.venueKey +
									'/' +
									rec.imageKey +
									'?' +
									timestamp
								"
							/>
						</div>
						<div class="display-2 text-center">{{ rec.displayName || rec.name }}</div>
						<div class="text-center lead mt-4">{{ rec.description }}</div>
					</div>
				</div>
			</ng-container>
		</div>
		<div class="w-75 h-100 overflow-scroll">
			<app-kiosk-menu-items
				*ngIf="canvasKeySelected"
				[canvasKeySelected]="canvasKeySelected"
				[canvasMenuItemSelected]="canvasMenuItemSelected"
				(canvasMenuItemSelectedEmitter)="canvasMenuItemSelected = $event"
			></app-kiosk-menu-items>
		</div>
	</div>

	<app-kiosk-menu-item-selected
		*ngIf="canvasMenuItemSelected"
		[canvasMenuItem]="canvasMenuItemSelected"
		(closeDialogEmitter)="canvasMenuItemSelected = undefined"
	></app-kiosk-menu-item-selected>
</div>
